export default "__VITE_ASSET__SuTlAIIA__"